import { Injectable } from '@angular/core';
import {Headers, Http} from "@angular/http";
import {environment} from "../../environments/environment";

@Injectable()
export class LoginService {
    private json: any;
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    constructor(private http: Http) { }

    //login check
    loginCall(email_address,password){
        let body = "vEmail="+email_address+"&vPassword="+password
        const promise = new Promise((resolve, reject) => {
          const apiURL = environment.BASE_URL+'/login';
          this.http.post(apiURL,body,{headers: this.headers})
            .toPromise()
            .then(
              res => { // Success
                //console.log(res.json());
                resolve(res.json());
              }
            ).catch(
            err => {
              console.log(err.json());
              reject(err.json());
            }
          );
        });
        return promise;
    }

    //Verify email sent on user register from application
    verifyMail(key){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/verifyemail/'+key;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/login/login.service.ts